<div class="add-note-container">
  <h3>Add Note</h3>
  <form [formGroup]="noteForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="account">Account</label>
      <select id="account" formControlName="account" class="form-control">
        <option *ngFor="let account of accounts" [ngValue]="account">{{ account.accountName }} ({{ account.accountNumber }})</option>
      </select>
    </div>
    <div class="form-group">
      <label for="notes">Notes</label>
      <textarea id="notes" formControlName="notes" class="form-control" rows="3"></textarea>
    </div>
    <div class="form-group form-check">
      <input type="checkbox" id="preserve" formControlName="preserve" class="form-check-input">
      <label for="preserve" class="form-check-label">Preserve</label>
    </div>
    <button type="submit" class="btn btn-primary" [disabled]="noteForm.invalid">Add Note</button>
  </form>
</div>
